import {orderBy} from "lodash"
import teamsService from "../../services/teams"

export const SET_TEAMS = "SET_TEAMS"
export const UPDATE_TEAM = "UPDATE_TEAM"
export const ADD_TEAM = "ADD_TEAM"
export const DELETE_TEAM = "DELETE_TEAM"

const set = ({list}) => {
  return {
    type: SET_TEAMS,
    list
  }
}

const update = (team) => {
  return {
    type: UPDATE_TEAM,
    team
  }
}

const add = (team) => {
  return {
    type: ADD_TEAM,
    team
  }
}

const remove = (team) => {
  return {
    type: DELETE_TEAM,
    team
  }
}

/** @author: Richard 8/3/2018
 * Get the Teams and append the load prop onto the list so we know if that list has loaded and can be called
 * as many times as required with only making one request.
 */
export const getTeams = (tenant, options = {}) => {
  return (dispatch, getState) => {
    const list = getState().teams.list
    if (shouldLoad(list, options)) {
      list.load = teamsService.list(tenant.uuid, options, {fetchPolicy: "network-only"}).then((teams) => {
        const orderedTeams = orderBy(teams, "public_name", "asc")
        orderedTeams.load = list.load
        return dispatch(set({list: orderedTeams}))
      })
    }
    return list.load
  }
}

export const updateTeam = (tenant, _team, team) => {
  return (dispatch) => {
    return teamsService.update(tenant.uuid, team, team.Etag).then((updatedTeam) => {
      return dispatch(update(updatedTeam))
    })
  }
}

export const createTeam = (tenant, name) => {
  return (dispatch) => {
    const team = {public_name: name}
    return teamsService.create({tenantId: tenant.uuid, data: team}).then((createdTeam) => {
      dispatch(add(createdTeam))
      return createdTeam
    })
  }
}

export const deleteTeam = (tenant, team) => {
  return (dispatch) => {
    return teamsService.delete(tenant.uuid, team.uuid, team.Etag).then(() => {
      return dispatch(remove(team))
    })
  }
}

export default {
  get: getTeams,
  create: createTeam,
  deleteTeam,
  updateTeam
}

/** @author: Richard 11/6/18
 *  @desc: Only reload teams if no load promise present (never loaded before)
 *         or if user limit is requests but we have no users array.
 */
function shouldLoad(list, options) {
  if (!list.load) return true

  if (options.userLimit && list[0]) {
    return !list[0].users
  }

  return false
}
